module.exports = __webpack_public_path__ + "img/image-placeholder.7746f161.png";